export const productsSliderOptions = (instance, options) => {
    let onEvents = {}
    let responsiveItemCounts = {
        1024: 4,
        1280: 5,
    }

    if (instance.classList.contains('is-article-content')) {
        responsiveItemCounts = {
            1024: 4
        }

        onEvents.afterInit = (swiper) => {
            if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
                swiper.$el[0].classList.add('wanna-be-centered');
            } else {
                swiper.$el[0].classList.remove('wanna-be-centered');
            }
        }

        onEvents.resize = (swiper) => {
            if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
                swiper.$el[0].classList.add('wanna-be-centered');
            } else {
                swiper.$el[0].classList.remove('wanna-be-centered');
            }
        }
    }

    let breakpoints = {}
    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        cssMode: true,
        breakpoints: breakpoints,
        on: onEvents
    }
}

export const compactProductsSliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        loop: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 24,
        cssMode: true,
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                pagination: {
                    dynamicBullets: false,
                }
            }
        },
        on: onEvents
    }
}

export const combidealProductsSliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        cssMode: false,
        breakpoints: {
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            480: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                cssMode: true,
            }
        },
        on: onEvents
    }
}

export const similarProductsSliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        loop: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 24,
        cssMode: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        },
        on: onEvents
    }
}

export const dashboardProductsSliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        cssMode: true,
        breakpoints: {
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 8,
                cssMode: false,
            },
        },
        on: onEvents
    }
}

export const endedProductsSliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 12,
        cssMode: true,
        on: onEvents
    }
}

export const articleProductsSliderOptions = (instance, options, maxVisibleItems) => {
    let responsiveItemCounts = {
        1024: 3,
        1280: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxVisibleItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 20,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        cssMode: true,
        breakpoints: breakpoints
    }
}